import { Browser } from '@capacitor/browser';
import { isNative } from './is-native';

/**
 * Open an external website in the system browser — SFSafariViewController on
 * iOS, Chrome Custom Tabs on Android. Used for links that must leave the app
 * binary entirely, e.g. managing the subscription on the web (App Store
 * guideline 3.1.3(b): a multiplatform service may link to the developer's
 * website for account management, but must not show prices or a purchase CTA
 * inside the app).
 *
 * On web/PWA this opens a new tab.
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (isNative()) {
    await Browser.open({ url });
    return;
  }
  if (typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
